import { StyleSheet } from 'react-native';
import { SPACING, RADIUS, COLORS, SHADOWS, TYPOGRAPHY } from '../constants/theme';

/**
 * Shared button styles for consistent theming across all buttons
 * To change the theme, update the constants in theme.ts
 */
export const ButtonStyles = StyleSheet.create({
    // Base button styles
    btn: {
        paddingHorizontal: SPACING.xl,
        paddingVertical: SPACING.md,
        borderRadius: RADIUS.lg,
        minHeight: 44,
        alignItems: 'center',
        justifyContent: 'center',
        ...SHADOWS.md,
    },
    btnIcon: {
        paddingHorizontal: SPACING.md,
        minWidth: 44,
    },
    
    // Primary button
    btnPrimary: {
        backgroundColor: COLORS.button.primary,
        borderWidth: 2,
        borderColor: COLORS.button.primaryBorder,
    },
    btnPrimaryText: {
        color: COLORS.button.primaryText,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        fontSize: TYPOGRAPHY.fontSize.md,
        includeFontPadding: false,
    },
    
    // Secondary button
    btnSecondary: {
        backgroundColor: COLORS.button.secondary,
        borderWidth: 2,
        borderColor: COLORS.button.secondaryBorder,
    },
    btnSecondaryText: {
        color: COLORS.button.secondaryText,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        fontSize: TYPOGRAPHY.fontSize.md,
        includeFontPadding: false,
    },
    
    // Button size variants
    btnFull: {
        flex: 1,
        minWidth: 120,
    },
    btnLarge: {
        paddingHorizontal: SPACING.xl * 2,
        paddingVertical: 16,
        fontSize: TYPOGRAPHY.fontSize.lg,
    },
    
    // Button state variants
    btnDisabled: {
        opacity: 0.6,
    },
    
    // Additional button variants
    btnWarning: {
        backgroundColor: COLORS.warning,
        borderWidth: 2,
        borderColor: COLORS.warning,
    },
    btnWarningText: {
        color: COLORS.white,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        fontSize: TYPOGRAPHY.fontSize.md,
        includeFontPadding: false,
    },
    btnSuccess: {
        backgroundColor: COLORS.success,
        borderWidth: 2,
        borderColor: COLORS.success,
    },
    btnSuccessText: {
        color: COLORS.white,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        fontSize: TYPOGRAPHY.fontSize.md,
        includeFontPadding: false,
    },
    btnInfo: {
        backgroundColor: COLORS.accentBlue,
        borderWidth: 2,
        borderColor: COLORS.accentBlue,
    },
    btnInfoText: {
        color: COLORS.white,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        fontSize: TYPOGRAPHY.fontSize.md,
        includeFontPadding: false,
    },
    btnDanger: {
        backgroundColor: COLORS.error,
        borderWidth: 2,
        borderColor: COLORS.error,
    },
    btnDangerText: {
        color: COLORS.white,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        fontSize: TYPOGRAPHY.fontSize.md,
        includeFontPadding: false,
    },
});
